export default __webpack_public_path__ + "static/media/55YearsGPALogo.92a27abb.jpeg";